<div class="grid">
  <div class="grid__col-sm-6">
    <div class="border bg-color-ebony-a03 guts-m-t-1 guts-p-full-1">
      <p><df-icon icon="office"></df-icon>&nbsp;{{ message }}</p>
    </div>
  </div>
</div>
